import initApplicationGlobal from '../Global/Global';
import initCalc from '../HomePage/initCalc';

export default function initApplicationHomePage(eventHub) {
  initApplicationGlobal(eventHub);

  if (document.querySelector('#calculator')) {
    initCalc(false, true);
  }
}
